/**
 * The tool an agent calls to message another agent or the lead.
 *
 * Shared because two sides key on it and a literal in either would drift from
 * the other: the runner watches the call to record who sent what, and the
 * transcript renders it as the message it is rather than as an anonymous tool
 * step.
 */
export const SEND_MESSAGE_TOOL_NAME = "SendMessage" as const;
